module.exports = __webpack_public_path__ + "static/media/spinner.d88105a8.gif";